import React from 'react';

interface NavigationLinkProps extends React.AnchorHTMLAttributes<HTMLAnchorElement> {
  href: string;
  children: React.ReactNode;
  className?: string;
  onClick?: (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => void;
}

const NavigationLink: React.FC<NavigationLinkProps> = ({ href, children, className, onClick, ...props }) => {
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
    // If they middle-click or Cmd/Ctrl click, let the browser handle it.
    if (e.button === 1 || e.metaKey || e.ctrlKey || e.shiftKey) {
      return;
    }
    
    // Normal single click overrides standard navigation.
    e.preventDefault();
    if (onClick) {
        onClick(e);
    } else {
        try {
            window.history.pushState({}, '', href);
            const navEvent = new PopStateEvent('popstate');
            window.dispatchEvent(navEvent);
            window.scrollTo(0, 0);
        } catch (err) {
            window.location.href = href;
        }
    }
  };

  return (
    <a href={href} className={className} onClick={handleClick} {...props}>
      {children}
    </a>
  );
};

export default NavigationLink;
